import { smartbizUrl } from './ApiClient';


/* TODO : Add react-query to enable other features */

export const getFeatureFlagStatus = async (featureFlagName: string, defaultBehaviour: boolean, storeId?: string): Promise<boolean> => {
    try {
        const response = await smartbizUrl.get(`feature-configs/flags/${featureFlagName}`, {
            params: storeId ? { storeId } : {}
        });
        return response.data;
    }
    catch {
        return defaultBehaviour;
    }
};